import styled from 'styled-components';
import { cssprops } from '@vfit/shared/themes';
import { IPassword } from './password.models';

export const Container = styled.div<Pick<IPassword, 'styled'>>`
  position: relative;
  ${cssprops.styled}
`;
